export default {
    NONE: 0,
    WORDPRESS: 1,
    PRESTASHOP: 2,
    JOOMLA: 3,
    MAGENTO: 4,
    OPENCART: 5,
    MIXIN: 6,
    PORTAL: 7,
    SHOPFA: 8,
    WEBZI: 9,
    OTHER: 100,
}